export function api_post(endpoint, body) {
    return fetch(endpoint, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    })
    .then((res) => res.json())
    .catch((err) => console.error(err));
}

export function api_get(endpoint) {
    return fetch(endpoint)
    .then((res) => res.json())
    .catch((err) => console.error(err));
}